import styled from 'styled-components';
export var FakeInput = styled.span.withConfig({
  displayName: "elements__FakeInput",
  componentId: "gge6fp-0"
})(["display:flex;justify-content:center;align-items:center;width:", ";background:", ";border-top:1px solid ", ";border-bottom:1px solid ", ";color:", ";"], function (_ref) {
  var width = _ref.width;
  return width;
}, function (_ref2) {
  var palette = _ref2.theme.palette;
  return palette.white;
}, function (_ref3) {
  var palette = _ref3.theme.palette;
  return palette.lightGrey;
}, function (_ref4) {
  var palette = _ref4.theme.palette;
  return palette.lightGrey;
}, function (_ref5) {
  var palette = _ref5.theme.palette;
  return palette.darkBlue;
});